import React from "react";
import { Home } from "lucide-react";
import SharedDashboardLayout from "./shared-dashboard-layout";
import { useAuth } from "../../context/auth-context";

const AccountLayout = () => {
  const { user } = useAuth();

  // Determine which dashboard to return to based on active role
  const dashboardHref = user?.activeRole === "handyman"
    ? "/handyman/dashboard"
    : user?.activeRole === "customer"
      ? "/customer/dashboard"
      : user?.activeRole === "marketing_executive"
        ? "/emp/dashboard"
        : "/dashboard";

  const sidebarLinks = [
    {
      title: "Back to Dashboard",
      href: dashboardHref,
      icon: Home
    }
  ];

  return (
    <SharedDashboardLayout 
      sidebarLinks={sidebarLinks} 
      defaultRole="customer" 
    />
  );
};

export default AccountLayout;
